<template>
  <section class="timeline">
    <TimelineHeader :categorypages="categorypages" v-model="selection" />
    <main>
      <template v-for='item in itemsbydate'>
        <article v-if='selection.toLowerCase()==item?.parent.id || selection == "All"' :class='[ item?.parent.id ], {"big": true}'>
          <header>
            <h5 class='category' v-html="item?.parent.content?.title" />
            <h5 v-if='item?.content.date' v-html="dayjs(item?.content.date).format('MMMM D, YYYY')" />
          </header>
          <h3 v-html="item?.title" />
          <LayoutBlock :block='block' :context='item' v-if='item?.content?.content' v-for='(block, index) in JSON.parse(item?.content?.content)' :key="index"/>
          <footer v-if='item?.parent.id == "writing"'>
            <ReadMore :item='item' />
          </footer>
        </article>
      </template>
    </main>
  </section>
</template>

<script setup>
import dayjs from 'dayjs';
const props = defineProps(['timelineitems', 'categorypages']);
const itemsbydate = computed(()=>props.timelineitems.filter(item => {
  const hide = item.content?.hidefromfrontpage;
  return hide !== true && hide !== "true" && hide !== "1";
}).sort((a, b) => dayjs(b.content.date).diff(dayjs(a.content.date))));
const selection = ref('All');
</script>

<style scoped>
main {
  max-width: clamp(calc(100vw - 4rem), var(--main-width), var(--main-width));
  margin: auto;
  margin-top: 12rem;
  position: relative;
  display: flex;
  flex-direction: column;
}

@media (min-width: 1080px) {

  main::before {
    position: absolute;
    top: -5rem;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--gray);
    margin: auto;
    height: 100%;
    width: 1px;
    color: var(--light);
    content: '';
  }

  main article:not(.photographs) {
    width: 50%;
    margin-top: 5rem;
    margin-bottom: 5rem;
    position: relative;
    min-height: 20rem;
  }

  main article:nth-child(odd) {
    align-self: flex-start;
  }

  main article:nth-child(even) {
    align-self: flex-end;
  }

  article:not(.photographs)::before {
    content: '';
    position: absolute;
    top: 2.5rem;
    width: 3.5rem;
    border-top: 1px solid var(--gray);
  }

  main article.writing:nth-child(odd) {
    display: flex;
    flex-direction: column;
    align-items: end;
  }

  article:nth-child(odd)::before {
    right: 0;
  }

  article:nth-child(even)::before {
    left: 0;
  }

  main article.photographs:nth-child(odd) {
    margin-left: clamp(2em, 10%, 10rem);
    margin-right: auto;
  }

  main article.photographs:nth-child(even) {
    margin-left: auto;
    margin-right: clamp(2em, 10%, 10rem);
  }
}

@media (max-width: 1080px) {

  main {
    top: -5rem;
    width: clamp(400px, 100%, 30rem);
  }

  main::before {
    position: absolute;
    top: 5.2rem;
    bottom: 0;
    left: 0;
    background-color: var(--gray);
    margin: auto;
    height: 100%;
    width: 1px;
    color: var(--light);
    content: '';
   }

   main article {
     width: auto;
     margin-bottom: 5rem;
     position: relative;
     min-height: 20rem;
   }

   main article.writing {
     padding: 0 3rem;
   }

   main article.photographs:nth-child(even) {
     margin-left: 2rem;
     margin-right: clamp(2em, 10%, 10rem);
   }

   main article.photographs:nth-child(odd) {
     margin-left: 4rem;
     margin-right: clamp(2em, 10%, 10rem);
   }

   article:not(.photographs)::before {
     content: '';
     position: absolute;
     top: 2.5rem;
     width: 2rem;
     border-top: 1px solid var(--gray);
     left: 0;
   }

   article.photographs:nth-child(odd)::before {
     content: '';
     position: absolute;
     top: 2.5rem;
     border-top: 1px solid var(--gray);
     width: 4rem;
     left: -4rem;
   }

   article.photographs:nth-child(even)::before {
     content: '';
     position: absolute;
     top: 2.5rem;
     border-top: 1px solid var(--gray);
     width: 2rem;
     left: -2rem;
   }
}

article h5.category {
  color: var(--gray);
}

article h3 {
  margin-bottom: 0.66em;
}

article.writing :deep(div.textblock), article.writing :deep(header), article.writing :deep(h3), article.writing :deep(footer) {
  width: clamp(30rem, 100%, 36rem);
  display: block;
}

article.writing {

}

main article.photographs {
  max-width: 100rem;
  margin-bottom: 20rem;
  position: relative;
  border: 1px solid var(--graphite);
  padding: 2em 2.5em;
  background: black;
  z-index: 99;
}

article.writing h3 {
  font-size: 4.5rem;
}

article :deep(div.textblock) {
  max-height: 30rem;
  overflow: hidden;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 90%,transparent 99%);
}

article {
  box-sizing: border-box;
  padding: 0 4rem;
}

article header {
  display: flex;
  justify-content: space-between;
}

article.writing header {
  flex-direction: column;
}

article.writing {
  box-sizing: border-box;
  padding: 0 6rem;
}

article :deep(.youtube.wrapper) {
  aspect-ratio: 16 / 9;
}


</style>
